export const fadeInUpAnimation = {
  animation: 'fadeInUp 0.3s ease-out',
  '@keyframes fadeInUp': {
    from: {
      opacity: 0,
      transform: 'translateY(20px) scale(0.95)',
    },
    to: {
      opacity: 1,
      transform: 'translateY(0) scale(1)',
    },
  },
};

export const greenFadeOutAnimation = {
  '@keyframes greenFadeOut': {
    from: { backgroundColor: 'rgba(0, 255, 0, 0.3)' },
    to: { backgroundColor: 'transparent' },
  },
};

export const slideInAnimation = {
  '@keyframes slideInLeft': {
    from: { transform: 'translateY(-100px)' },
    to: { transform: 'translateY(0)' },
  },
};
